export const formatPhoneNumber = (phone: string): string => {
  if (!phone) {
    return '';
  }

  const numericValue = phone.replace(/\D/g, '');
  let formattedValue = '';

  if (numericValue.length === 0) {
    return '';
  }

  if (numericValue.length > 0) {
    formattedValue += `(${numericValue.slice(0, 3)}`;
  }

  if (numericValue.length > 3) {
    formattedValue += `)${numericValue.slice(3, 6)}`;
  }

  if (numericValue.length > 6) {
    formattedValue += `-${numericValue.slice(6, 10)}`;
  }

  return formattedValue;
};
